import { cn } from '@/lib/utils'

interface DetailRowProps {
  label: string
  value: string
  /** Sub-item (indentado, menor) — ex.: cada custo discriminado. */
  sub?: boolean
}

/** Linha de detalhamento do cartão: rótulo à esquerda, valor (mono) à direita. */
export function DetailRow({ label, value, sub }: DetailRowProps) {
  return (
    <div className={cn('flex justify-between', sub ? 'py-[3px] text-xs' : 'py-1.5 text-[13px]')}>
      <span className={cn(sub ? 'pl-2.5 text-ink-faint' : 'text-ink-mute')}>
        {sub ? `· ${label}` : label}
      </span>
      <span className={cn('font-mono tabular-nums', sub ? 'text-ink-mute' : 'text-ink')}>{value}</span>
    </div>
  )
}

type RowTone = 'ink' | 'brand' | 'neg'

const toneClass: Record<RowTone, string> = {
  ink: 'text-ink',
  brand: 'text-brand',
  neg: 'text-neg',
}

interface RowStrongProps {
  label: string
  value: string
  tone?: RowTone
}

/** Linha-total em destaque (topo com filete), usada no fim do cartão. */
export function RowStrong({ label, value, tone = 'ink' }: RowStrongProps) {
  return (
    <div className="mt-[5px] flex justify-between border-t border-line-soft pt-2 text-[13px]">
      <span className={cn('font-medium', toneClass[tone])}>{label}</span>
      <span className={cn('font-mono font-semibold tabular-nums', toneClass[tone])}>{value}</span>
    </div>
  )
}
